import React, { FC } from 'react';

import styles from './styles.module.css';

interface IOccupantProps {
  name: string;
  zone: string;
}

export const Occupant: FC<IOccupantProps> = ({ name, zone }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{name}</div>
      <div className={styles.title}>{zone}</div>
    </div>
  );
};
